<p-dialog
  [(visible)]="visible"
  (onHide)="hide()"
  [modal]="true"
  [style]="{width: '500px'}"
  [draggable]="false"
  [showHeader]="false">

  <div class="export-modal-content">
    <div class="export-header">
      <h2>{{ 'EXPORT_DATA' | translate }}</h2>
      <button type="button" class="close-button" (click)="hide()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="export-body">
      <div class="export-field">
        <label>{{ 'EXPORT_FORMAT' | translate }}</label>
        <msf-select
          [(model)]="exportFormat"
          [options]="exportFormatOptions"
          optionLabel="label"
          optionValue="value"
          translateBy="none"
          [placeholder]="'SELECT_FORMAT' | translate"
          [style]="{'width':'100%'}">
        </msf-select>
      </div>
    </div>

    <div class="export-footer">

      <app-primary-button
        [title]="'DOWNLOAD'"
        (action)="startExport()"
        [loading]="isExporting"
      ></app-primary-button>

      <app-primary-button
        [title]="'CLOSE'"
        (action)="hide()"
      ></app-primary-button>
    </div>

  </div>
</p-dialog>
